import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "card custom-shadow rounded-3 bg-white border mb-4",
  style: {"padding-bottom":"24px"}
}
const _hoisted_2 = { class: "default-table-area style-three popular-hosts" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle border-0" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-grow-1 ms-10" }
const _hoisted_9 = { class: "fs-14 fw-medium mb-0" }
const _hoisted_10 = { class: "fs-12 text-body fw-normal" }
const _hoisted_11 = { class: "d-block fs-14 fw-medium" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  class: "follow-text position-relative",
  style: {"top":"-1px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", {
      class: "d-flex justify-content-between align-items-center flex-wrap gap-3 custom-padding-30 position-relative pb-3",
      style: {"top":"-5px"}
    }, [
      _createElementVNode("h3", { class: "mb-0 fs-18 fw-semibold" }, "Popular Hosts"),
      _createElementVNode("button", {
        class: "bg-transparent border-0 p-0 d-flex align-items-center text-decoration-none position-relative right-for-rtl text-body",
        style: {"right":"-8px"}
      }, [
        _createElementVNode("span", null, "View All"),
        _createElementVNode("i", { class: "ri-arrow-right-s-line fs-24 position-relative top-1 lh-1 text-body" })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hosts, (host) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: host.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: host.image,
                        style: {"width":"40px","height":"40px"},
                        class: "rounded-circle",
                        alt: "user"
                      }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", _hoisted_9, _toDisplayString(host.name), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(host.category), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(host.hosted), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-block fs-12 fw-normal text-body" }, "Hosted", -1))
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.toggleFollow(host)),
                    class: _normalizeClass([
                    'border-0 text-primary follow-button fs-14',
                    { followed: host.isFollowing },
                  ]),
                    style: {"background-color":"#ecf0ff","padding":"4.5px 10px","border-radius":"4px"}
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(host.isFollowing ? "Following" : "Follow"), 1)
                  ], 10, _hoisted_13)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}